import React, {useEffect, useState} from 'react';
import {useQuery} from '@tanstack/react-query';
import {request} from "../lib/request";
import {useUser} from "./UserInfo";

const NotificationProvider = ({children}) => {
    const {sessionActive} = useUser();
    const [pollReady, setPollReady] = useState(false);

    useEffect(() => {
        if (!sessionActive) {
            setPollReady(false);
            return undefined;
        }

        const timer = window.setTimeout(() => setPollReady(true), 1500);
        return () => window.clearTimeout(timer);
    }, [sessionActive]);

    const {data, isSuccess, fetchStatus} = useQuery({
        queryKey: ['notificationStatus'],
        queryFn: async () => request({
            url: "/restaurant/hasPendingOrder",
            method: "get"
        }),
        enabled: sessionActive && pollReady,
        refetchInterval: sessionActive && pollReady ? 30000 : false,
        refetchIntervalInBackground: false,
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 1000 * 15,
    });

    const prevFetchStatus = React.useRef(fetchStatus);

    useEffect(() => {
        if (prevFetchStatus.current === 'fetching' && fetchStatus === 'idle' && isSuccess && data?.data.havePending) {
            if (Notification.permission !== 'granted') {
                Notification.requestPermission();
            }

            if (Notification.permission === 'granted') {
                new Notification('غذارسان', {
                    body: 'سفارش تایید نشده وجود دارد.',
                    icon: '/images/logo1.png',
                });
            }

            const audio = new Audio('notification.mp3');
            audio.play().catch(() => {});
        }
        prevFetchStatus.current = fetchStatus;
    }, [fetchStatus, isSuccess, data]);

    return <>{children}</>;
};

export default NotificationProvider;
